/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M50.465 24.936c5.505 0 9.968-4.463 9.968-9.968S55.97 5 50.465 5s-9.968 4.463-9.968 9.968 4.463 9.968 9.968 9.968zm18.481 31.898a5.98 5.98 0 000-11.962 19.98 19.98 0 01-18.573-12.64 5.98 5.98 0 00-11.14 1.173L25.278 87.233A5.98 5.98 0 1036.84 90.23l4.593-17.72a32.033 32.033 0 017.604 16.962 5.981 5.981 0 0011.87-1.479 44.027 44.027 0 00-16.053-28.68l2.76-10.646a31.655 31.655 0 0021.331 8.166z"
    ></path>
  </Svg>
)

export default Icon
